import { FC, useContext, useEffect } from 'react'
import { IonRouterContext } from '@ionic/react'

import { appConfig } from '@/services/config'
import { Context } from '@lib/store'
import {
  UserInterestsStatus,
  useUserInterestsStatus,
} from '@/lib/hooks/useUserInterestsStatus'
import { Routes } from '@/router/routes'
import { isInStandaloneMode } from '@/utils/isInStandaloneMode'
import { isMobileWeb } from '@/utils/utils'

export const RedirectToLogin: FC = () => {
  const ionRouterContext = useContext(IonRouterContext)
  const { state } = useContext(Context)
  const { userInterestsStatus } = useUserInterestsStatus()

  useEffect(() => {
    if (userInterestsStatus === UserInterestsStatus.InProgress) {
      // if user hasn't filled in InterestsSurvey form
      ionRouterContext?.push(Routes.AUTH_CREATE_INTERESTS_SURVEY)
    } else if (state.signInRedirectPath) {
      // eg for referral signups, signInRedirectPath is the profile page of the referring user
      ionRouterContext?.push(state.signInRedirectPath, 'root')
    } else {
      if (
        userInterestsStatus === UserInterestsStatus.Done &&
        appConfig.forceMobileWebPWA &&
        isMobileWeb() &&
        !isInStandaloneMode()
      ) {
        ionRouterContext?.push(Routes.PWA_ONBOARDING)
      } else {
        ionRouterContext?.push(Routes.FEED)
      }
    }
  }, [ionRouterContext, userInterestsStatus, state.signInRedirectPath])

  return null
}
